import { render } from "./ClickSignRequestReviewComponent.vue?vue&type=template&id=307892d8&scoped=true"
import script from "./ClickSignRequestReviewComponent.vue?vue&type=script&lang=js"
export * from "./ClickSignRequestReviewComponent.vue?vue&type=script&lang=js"

import "./ClickSignRequestReviewComponent.vue?vue&type=style&index=0&id=307892d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307892d8"]])

export default __exports__